<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :liveSearching="true"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/exit_check_item_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "name",
      "area",
      "area_section",
      "industry_categories",
      "system_class",
      "updated_info",
      "updated_admin",
    ],
    sortBy: "sequence",
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "篩選地區",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        label: "",
        type: "hasMany",
        textKey: "name",
        modelName: "area_section",
        placeholder: "篩選子地區",
        hasNoSearch: true,
        hasAllSelectBtn: true,
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "multiple-layer-select",
        label: "",
        textKey: "name",
        modelName: "system_subclasses",
        getUrl: "system_class",
        placeholder: "篩選領域/子領域",
        orderBy: "sequence",
        orderWay: "asc",
      },
      // {
      //   conditionKeys: [
      //     {
      //       fieldName: "area",
      //       conditionName: "area",
      //       type: "array",
      //     },
      //   ],
      //   requiredField: "area",
      //   type: "hasMany",
      //   label: "",
      //   textKey: "name",
      //   modelName: "industry_category",
      //   placeholder: "篩選產業類別",
      // },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "is_active",
        defaultValue: "1",
        items: [
          {
            value: "1",
            text: "顯示",
          },
          {
            value: "0",
            text: "隱藏",
          },
        ],
      },
    ],
  }),
};
</script>

<style>
</style>